import { BookingVehicleInfoCard } from "../BookingVehicleInfoCard/BookingVehicleInfoCard";
import React, { useEffect, useMemo, useState } from "react";
import { Vehicle } from "../../../@types/DTO/Vehicles";
import { ShowVehiclesProps } from "./ShowVehiclesProps";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import "./Scrollbar.css";
import BookingGetters from "../../../store/onlineBooking/getters";
import { useTranslation } from "react-i18next";

export function ShowVehicles({
  vehiclesFilter = {
    status: {},
    category: {},
    type: {},
    TotalSeats: [],
    MacroGroup: {},
    Transmission: {},
  },
  allVehicles = [],
  className = "",
  textColor = "",
  backgroundColor = "",
  onVehicleSelect = () => {},
  backgroundTextColor = "",
  locationName,
  longitude,
  latitude,
}: ShowVehiclesProps): JSX.Element {
  const memoizedVehicleFilter = useMemo(() => vehiclesFilter, [vehiclesFilter]);
  const [availableVehicles, setAvailableVehicles] = useState<Vehicle[]>([]);
  const [showingVehicles, setShowingVehicles] = useState<Vehicle[]>([]);
  const [isLoadingMoreVehicles, setIsLoadingMoreVehicles] =
    useState<boolean>(false);
  const appSettings = BookingGetters.getAppSettings();
  const bookingDetails = BookingGetters.getBookingDetails();
  const enableFilterBySeat = appSettings && appSettings["enableFilterBySeat"];
  const enableFilterByFuel = appSettings && appSettings["enableFilterByFuel"];
  const enableFilterByTransmission =
    appSettings && appSettings["enableFilterByTransmission"];
  const istabletScreen = window.innerWidth >= 768 && window.innerWidth <= 1220;
  // function addAvailableVehicles() {
  //   const result: Vehicle[] = availableVehicles;
  //   if (result.length) {
  //     setShowingVehicles((e) => {
  //       return [...e, ...result];
  //     });
  //   }
  //   return result;
  // }
  const { t: translate } = useTranslation();
  function loadMoreVehicles() {
    // let result: Vehicle[] = [];
    setIsLoadingMoreVehicles(true);
    // if (
    //   vehiclesFilter?.status["available"] &&
    //   showingVehicles.length < availableVehicles.length
    // ) {
    //   result = [...result, ...addAvailableVehicles()];
    // }
    // if (!Object.values(vehiclesFilter?.status || {}).length) {
    //   // result = [...result, ...addAvailableVehicles()];
    // }
    setIsLoadingMoreVehicles(false);
  }
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";
  function requestParentResize() {
    const iframeHeight = document.body.scrollHeight;
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: iframeHeight - 350,
        },
      },
      targetOrigin
    );
  }

  useEffect(() => {
    requestParentResize();
  }, [showingVehicles]);

  function getPrice(vehicle) {
    return vehicle?.TotalCharge?.RateTotalAmount || 0;
  }

  function isOnRequest(status) {
    return status?.toLowerCase() === "onrequest";
  }

  function compareByOnRequest(a, b) {
    const aOnRequest = isOnRequest(a.Status);
    const bOnRequest = isOnRequest(b.Status);

    if (aOnRequest && !bOnRequest) return 1;
    if (!aOnRequest && bOnRequest) return -1;
    return 0;
  }

  function compareVehicles(a, b, showOnrequestVehicles) {
    const priceA = getPrice(a);
    const priceB = getPrice(b);

    if (priceA === 0 && priceB !== 0) return 1;
    if (priceB === 0 && priceA !== 0) return -1;

    if (showOnrequestVehicles) {
      const requestSort = compareByOnRequest(a, b);
      if (requestSort !== 0) return requestSort;
    }

    return priceA - priceB;
  }

  function segregateData() {
    setAvailableVehicles(
      (
        allVehicles.filter(
          (e) =>
            (e.Status.toLowerCase() === "available" ||
              (appSettings?.showOnrequestVehicles &&
                e.Status.toLowerCase() === "onrequest")) &&
            e?.TotalCharge?.RateTotalAmount != 0
        ) || []
      )
        .filter((vehicle) => {
          const length = Object.keys(vehiclesFilter.type).length;
          if (length < 1) {
            return true;
          }
          const fuelType =
            vehicle.Vehicle?.fuelType?.description?.toLowerCase() || "";
          return fuelType in vehiclesFilter.type;
        })
        .filter((e) => {
          if (!vehiclesFilter.TotalSeats.length) {
            return true;
          }
          return vehiclesFilter.TotalSeats.filter(
            (v) => v == (e.Vehicle?.seats.toString() || "0")
          ).length;
        })
        .filter((e) => {
          if (!Object.keys(vehiclesFilter.Transmission).length) {
            return true;
          }
          const selectedTransmission = vehiclesFilter.Transmission;
          const transmissionDescription =
            e.Vehicle?.transmission?.description?.toLowerCase() || "";
          return Object.keys(selectedTransmission)
            .map((e) => e.toLowerCase())
            .includes(transmissionDescription.toLocaleLowerCase());
        })
        // .sort((a, b) => {
        //   const priceA = a.TotalCharge?.RateTotalAmount || 0;
        //   const priceB = b.TotalCharge?.RateTotalAmount || 0;

        //   if (priceA === 0) return 1;
        //   if (priceB === 0) return -1;

        //   if (appSettings?.showOnrequestVehicles) {
        //     if (
        //       a.Status.toLowerCase() === "onrequest" &&
        //       b.Status.toLowerCase() !== "onrequest"
        //     ) {
        //       return 1;
        //     } else if (
        //       a.Status.toLowerCase() !== "onrequest" &&
        //       b.Status.toLowerCase() === "onrequest"
        //     ) {
        //       return -1;
        //     }
        //   }

        //   return priceA - priceB;
        // })
        .sort((a, b) =>
          compareVehicles(a, b, appSettings?.showOnrequestVehicles)
        )
    );
  }

  useEffect(() => {
    segregateData();
    RefreshData();
  }, [allVehicles]);

  useEffect(() => {
    segregateData();
    RefreshData();
  }, [vehiclesFilter]);

  function RefreshData() {
    setShowingVehicles([]);
    loadMoreVehicles();
  }

  useEffect(() => {
    RefreshData();
  }, [availableVehicles, memoizedVehicleFilter]);

  useEffect(() => {
    RefreshData();
  }, []);
  const isSmallScreen = window.innerWidth <= 768;
  const spanStyle: React.CSSProperties = {
    fontFamily: "MBCorpoSText-CondLight-Web",
    textAlign: isSmallScreen ? "left" : "initial",
    textIndent: isSmallScreen ? "" : "0.5em",
  };
  const spanClassName = `text-black font-normal ${
    isSmallScreen ? "float-left" : "float-left"
  }`;
  function normalizeVehicleParam(param: any) {
    const fileUrl = param["fileUrl :"] ?? param.fileUrl;
    const name = param["name :"] ?? param.name;
    const position = param["position :"] ?? param.position;

    return {
      iconUrl: fileUrl,
      name,
      value: position,
    };
  }

  function getSpecifications(vehicleParameter: any[]) {
    if (!Array.isArray(vehicleParameter) || vehicleParameter.length === 0)
      return [];
    return vehicleParameter.map(normalizeVehicleParam);
  }

  return (
    <>
      {!isLoadingMoreVehicles && (
        <div className={"w-full flex justify-center p-4 "}>
          <div className="w-full max-w-[92rem] grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {availableVehicles.length ? (
              availableVehicles.map((el: Vehicle, index) => {
                return (
                  <div
                    key={index}
                    className="flex flex-col overflow-hidden border-2 border-gray-300 rounded-lg cursor-pointer hover:border-blue-500"
                  >
                    <BookingVehicleInfoCard
                      extras={
                        el.optionals
                          ? el.optionals?.map((e) => {
                              return {
                                ...e,
                                iconUrl: e.Equipment.optionalImage || "#",
                                maxAllowed: e.Equipment.maxQuantity,
                                optionName: e.Equipment?.EquipType || "",
                                pricePerDayInUSD: (
                                  e.Charge.Amount || 0
                                ).toString(),
                                details: e.Equipment?.Description || "",
                              };
                            })
                          : []
                      }
                      discount={el.Vehicle?.payNowDis || 0}
                      status={el.Status}
                      modelYear=""
                      vehicleGroup={el.Vehicle?.groupPic?.nationalCode || ""}
                      priceDetails={{
                        payNow: (
                          el.TotalCharge?.RateTotalAmount || 0
                        ).toString(),
                        payLater: (
                          el.TotalCharge?.RateTotalAmount || 0
                        ).toString(),
                      }}
                      specifications={
                        el.Vehicle?.vehicleParameter
                          ? getSpecifications(el.Vehicle.vehicleParameter)
                          : []
                      }
                      topFeature={""}
                      latitude={latitude}
                      longitude={longitude}
                      dealerName={
                        bookingDetails?.pickUpLocationDetails?.dealerName
                      }
                      locationDescriptionName={
                        bookingDetails?.pickUpLocationDetails
                          ?.locationDescription
                      }
                      vehicleImages={[
                        el.Vehicle?.vehicleGroupPic || "",
                        ...(el.Vehicle?.vehicleExtraImage || []).filter((e) => {
                          return !!e;
                        }),
                      ]}
                      vehicleName={
                        appSettings?.showGroupWebDescription
                          ? el.Vehicle?.groupWebDescription ||
                            el.Vehicle?.VehMakeModel?.Name ||
                            ""
                          : el.Vehicle?.VehMakeModel?.Name || ""
                      }
                      payLater={"Pay Later"}
                      disclaimer={
                        "Le opzioni di questo veicolo da consegnare possono variare"
                      }
                      payNow={"Pay Now"}
                      selectExtra={"Choose Insurance"}
                      closeExtra={"Chiudi extra"}
                      viewAllSpecifications={"Visualizza tutte le specifiche"}
                      vehicleStatus={el.Status}
                      moveToPayment={(e) => {
                        onVehicleSelect({
                          vehicleDetails: el,
                          paymentDetails: e,
                        });
                      }}
                      textColor={textColor}
                      backgroundColor={backgroundColor}
                      backgroundTextColor={backgroundTextColor}
                      addedOnewayOOHFee={el.addedOnewayOOHFee}
                      addedOnewayFee={el.addedOnewayFee}
                      addedNoAgeFee={el.addedNoAgeFee}
                      addedYoungDriver2Fee={el.addedYoungDriver2Fee}
                      addedSeniorDriverFee={el.addedSeniorDriverFee}
                      addedYoungDriverFee={el.addedYoungDriverFee}
                      addedOOHFee={el.addedOOHFee}
                      theftExcessAmount={el.Vehicle?.theftAccessAmount}
                      damageExcessAmount={el?.Vehicle?.damageAccessAmount}
                      depositAmtFromOpt={el?.depositAmtFromOpt}
                      locationName={locationName}
                    />
                  </div>
                );
              })
            ) : (
              <>
                <div className="col-span-1 md:col-span-2 lg:col-span-3">
                  <div
                    style={{
                      marginLeft: isSmallScreen ? "0" : "121px",
                      padding: isSmallScreen ? "26px" : "0",
                      marginTop: isSmallScreen ? "" : "26px",
                      overflow: "hidden",
                      maxHeight: "100vh",
                    }}
                  >
                    <span
                      style={{
                        fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                        fontSize: "30px",
                        marginLeft: isSmallScreen ? "0" : "9px",
                      }}
                      className={`text-black font-bold float-left ${
                        !isSmallScreen ? "" : "-46%"
                      }`}
                    >
                      {translate("Sorry!")}
                    </span>
                    <br />
                    <br />
                    <span style={spanStyle} className={spanClassName}>
                      {translate(
                        "On the days and times you have indicated, there is currently no model from the Mercedes-Benz range."
                      )}
                    </span>
                    {!isSmallScreen && <br />}
                    <span style={spanStyle} className={spanClassName}>
                      {translate(
                        "Please try again in the next few days or select another period."
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {isLoadingMoreVehicles && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
